import { X } from "lucide-react";
import { createPortal } from "react-dom";

import { Button } from "@/components/ui/Button";
import { hubModalOverlayProps } from "@/components/ui/HubModalOverlay";
import { WarehouseRecountWorkspace } from "@/pages/warehouse/WarehouseRecountPage";

export function WarehouseRecountModal({
  open,
  initialSku,
  onClose,
}: {
  open: boolean;
  initialSku?: string | null;
  onClose: () => void;
}): JSX.Element | null {
  if (!open) return null;

  return createPortal(
    <div {...hubModalOverlayProps(true)}>
      <section
        role="dialog"
        aria-modal="true"
        aria-label="Recount inventory and create labels"
        className="flex max-h-[calc(100dvh-1rem)] w-full max-w-6xl flex-col overflow-hidden rounded-lg bg-slate-50 shadow-xl"
      >
        <header className="flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">Recount or create inventory label</h2>
            <p className="text-sm text-slate-600">Create a modern container label without leaving the active floor job.</p>
          </div>
          <Button type="button" variant="secondary" aria-label="Close recount" onClick={onClose}>
            <X className="h-4 w-4" aria-hidden />
          </Button>
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto p-4">
          <WarehouseRecountWorkspace embedded initialSku={initialSku ?? ""} />
        </div>
      </section>
    </div>,
    document.body,
  );
}
